import queryString from 'query-string';
import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';

enum SignUpType {
  existing_merchant_sign_up = 'existing_merchant_sign_up',
  merchant_sign_up = 'merchant_sign_up',
  invited_user_sign_up = 'invited_user_sign_up',
  merchant_self_serve_signup = 'merchant_self_serve_signup',
}

const isValidSignUpType = (v: any): v is keyof typeof SignUpType => {
  return typeof v === 'string' && Object.keys(SignUpType as object).includes(v);
};

const SignUpRedirectWrapper = () => {
  const { search } = useLocation();
  const signUpTypeParam = queryString.parse(search).signUpType;

  // If the param is not there at all, we assume this is an old email from before this functionality and send them
  // to the MerchantSignUp form
  if (signUpTypeParam === undefined) {
    return <Redirect to={`/draft-merchant-sign-up${search}`} />;
  }

  if (!isValidSignUpType(signUpTypeParam)) {
    return <Redirect to="/" />;
  }

  const signUpType = SignUpType[signUpTypeParam];

  switch (signUpType) {
    case SignUpType.existing_merchant_sign_up:
      return <Redirect to={`/existing-merchant-sign-up${search}`} />;
    case SignUpType.merchant_sign_up:
      return <Redirect to={`/draft-merchant-sign-up${search}`} />;
    case SignUpType.invited_user_sign_up:
      return <Redirect to={`/invited-user-sign-up${search}`} />;
    case SignUpType.merchant_self_serve_signup:
      return <Redirect to={`/merchant-self-serve-signup${search}`} />;
    default:
      const invalidType: never = signUpType;
      return invalidType;
  }
};

export default SignUpRedirectWrapper;
